import React, { useState } from "react"
import { Container, Row, Col } from "reactstrap"
import TaskList from "../../TaskManagement/TaskList"
import TaskManagementListHeader from "../../TaskManagement/TaskManagementListHeader"
import "./TasksTab.css"


const TasksTab = ({ incidentId }) => {
    const [orderBy, setOrderBy] = useState(['-date_added'])
    const [filterValues, setFilterValues] = useState({ searchTerm: '', incidentId: incidentId, isArchived: false })
    const boardId = process.env.REACT_APP_INCIDENT_BOARD_ID

    return (
        <div>
            <div className="incident-overview-header">
                <div className="incident-overview-header__titles">
                    <h3 className="incident-overview-header__title">Tasks</h3>
                    <p className="incident-overview-header__subtitle">Track and manage all tasks associated with this incident.</p>
                </div>
            </div>
            <Container fluid>
                <TaskManagementListHeader
                    activeTab="all"
                    parentBoardId={boardId}
                    filterValues={filterValues}
                    setFilterValues={(res) => setFilterValues({ ...res })}
                    incidentId={incidentId}
                />
            </Container>
            <Row>
                <Col className="TaskListColumn">
                    <TaskList {...filterValues} orderBy={orderBy} />
                </Col>
            </Row>
        </div>
    )
}

export default TasksTab
